/* HoneMD scroll-reveal — gentle fade/rise as elements enter the viewport.
   - Vanilla. IntersectionObserver as primary trigger, plus a throttled
     scroll/resize/load fallback so content is NEVER left stuck-hidden if IO
     doesn't fire (e.g. some embedded/automation contexts).
   - Only hides elements that start BELOW the fold, so there is no FOUC and
     above-the-fold content is never animated/hidden.
   - Fully disabled for prefers-reduced-motion (returns early; nothing hidden). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  var SELECTORS = [
    '.hm-section-head',
    '.hm-offer-card',
    '.hm-treatment-card',
    '.hm-review-card',
    '.hm-loc-card',
    '.hm-mcard',
    '.hm-glow__item',
    '.hm-glow__intro',
    '.rich-text__blocks',
    '.multicolumn-list__item',
    '.newsletter__wrapper'
  ];

  var pending = [];
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    : null;

  /* 4B a11y: reveals triggered by a programmatic viewport RESIZE (Lighthouse's
     full-page screenshot, orientation changes) complete INSTANTLY — axe-core was
     sampling text mid-fade and reporting fg≈bg "1.01:1" contrast phantoms. Real
     scroll-triggered reveals keep the fade. */
  var instantUntil = 0;
  window.addEventListener('resize', function () { instantUntil = Date.now() + 1500; }, { passive: true });

  function reveal(el) {
    if (!el || el.classList.contains('is-visible')) return;
    if (Date.now() < instantUntil) {
      el.style.transition = 'none';
      el.style.transitionDelay = '0ms';
    }
    el.classList.add('is-visible');
    if (io) io.unobserve(el);
    var i = pending.indexOf(el);
    if (i !== -1) pending.splice(i, 1);
  }

  var ticking = false;
  function check() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      if (pending[i].getBoundingClientRect().top < vh * 0.88) reveal(pending[i]);
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
  }

  function init(scope) {
    var root = scope || document;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    SELECTORS.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.hmRevealBound) return;
        el.dataset.hmRevealBound = '1';
        // Only animate elements that start below the fold.
        if (el.getBoundingClientRect().top > vh * 0.9) {
          el.classList.add('hm-reveal');
          var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
          var delay = Math.min(idx, 5) * 60;
          if (delay) el.style.transitionDelay = delay + 'ms';
          pending.push(el);
          if (io) io.observe(el);
        }
      });
    });
    check();
  }

  /* Safety net (B5 2026-07-11): reveal-on-scroll must be progressive
     enhancement, never a visibility dependency. If the visitor has NOT
     scrolled shortly after load — a static view, a full-page screenshot,
     an automation/headless context, or any environment where scroll/IO
     never fires — reveal every still-hidden element so content is never
     left stuck at visibility:hidden (which paints as a blank void). Engaged
     scrollers still get the per-element fade first; this only ever reveals,
     never hides, so no page can regress. */
  var userScrolled = false;
  function revealAllPending() { pending.slice().forEach(reveal); }

  window.addEventListener('scroll', function () { userScrolled = true; }, { passive: true, once: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', function () {
    check();
    setTimeout(function () { if (!userScrolled) revealAllPending(); }, 1200);
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
